import { isExternalDemoMode } from "./externalDemoMode"
import { isOnboardingFinished } from "./onboarding/isOnboardingFinished"

// Incognito (Private) mode is a Standard-mode-only feature. It must stay off — toggle hidden and
// nothing masked — in the admin panel, in Demo / External demo mode and while the user is still
// going through Onboarding. The flag itself is kept across logout (localStorage, see nav.slice) so
// it survives BA switching, which is exactly why every read has to go through this gate.
export const isIncognitoAvailable = (state) => {
  const auth = state?.auth

  if (!auth || auth.isAdmin) return false
  if (auth.userInfo?.is_demo) return false
  if (isExternalDemoMode(auth)) return false

  return isOnboardingFinished(auth.userInfo)
}

// The only source of truth for "should this value be masked right now".
export const selectIncognito = (state) => !!state?.nav?.incognito && isIncognitoAvailable(state)

// Live mirror of `selectIncognito` for the few call sites that mask outside React's render tree
// (chart.js draw/tick callbacks, legend plugins, column factories) and so cannot read the store.
// Kept in sync by the store subscription in `src/store.js`.
let incognitoActive = false

export const syncIncognitoActive = (state) => {
  incognitoActive = selectIncognito(state)
}

export const isIncognitoActive = () => incognitoActive

const EMAIL_RE = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g
// "by John Doe", "user John Doe", "requested by Anna-Maria O’Brien" — the connectors the backend
// uses when it names a person inside an activity log. Two or more capitalised words are required so
// single capitalised words (statuses, processor names, "Ticket") are left alone.
const NAME_RE = /\b(by|user|member|from user)\s+([A-Z][\p{L}'’-]+(?:\s+[A-Z][\p{L}'’-]+)+)/gu

// Log / activity messages are free-form text, so the only thing that can be masked is the PII
// inside them: the acting user's email and full name. Everything else (status, dates, ticket
// numbers) stays readable — see CHA1-1352.
export const maskLogPII = (text, mask) => {
  if (typeof text !== "string" || !text) return text

  return text.replace(EMAIL_RE, mask).replace(NAME_RE, (_, connector) => `${connector} ${mask}`)
}
